import { FC } from 'react';
import { RenderIfProps } from './types';

export const RenderIf: FC<RenderIfProps> = ({ isTrue, children }) => {
    return isTrue ? <>{children}</> : null;
};

export default RenderIf;

export type { RenderIfProps } from './types';
